module.exports = "/_next/static/images/Hero@2x-4bc6c55b04869279c578e5bfc6454368.webp";